import { useState } from 'react';
import * as React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css'
import 'react-toastify/dist/ReactToastify.css';
import { useLoadScript } from "@react-google-maps/api";

import './App.scss';

import Navigation from './navigation';
import { ToastContainer } from 'react-toastify';
const App = () => {
  const libraries: any = ["places"];
  useLoadScript({
    googleMapsApiKey: "AIzaSyCP5Nrx4IebOyv4MEWJWIAtE_6ZYCnzq_Q",
    libraries,
  });

  // Synchronously check and store parameters during render before routes evaluate
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  const tenantId = params.get("tenantId");
  const user = params.get("user");

  if (token && tenantId && user) {
    localStorage.setItem("access_token", token);
    localStorage.setItem("tenantId", tenantId);
    localStorage.setItem("user_info", user);

    const posWebUrl = params.get("posWebUrl");
    if (posWebUrl) {
      localStorage.setItem("pos_web_url", posWebUrl);
    }

    // Dynamic socket URL calculation
    const host = window.location.hostname;
    const defaultSocketUrl = (host === 'localhost' || host === '127.0.0.1')
      ? 'http://localhost:3007'
      : `http://${host}:3007`;
    localStorage.setItem('pos_socket_url', defaultSocketUrl);

    // Clean query params synchronously from the address bar
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  return (
    <>
      <div className="App">
        <Navigation />
        <ToastContainer />
      </div>
    </>
  );
};
export default App;
